<template>
  <div>
    <div>The system has been failure, please contact the administrator!</div>
    <a-button size="small" @click="()=>{this.visibles = !this.visibles}">
      Show Details
    </a-button>
    <br />
    <div v-if="visibles" style="max-height: 150px;overflow: auto;">
      {{valueError}}
    </div>
  </div>
</template>
<script>
  export default {
    name: "errorDisplay",
    props: {
      valueError: String
    },
    data() {
      return {
        visibles: false,
      };
    },
  };
</script>